namespace GeniuzPOS.Administration {
    export interface PsParaRow {
        Id?: number;
        ShopName?: string;
        BranchName?: string;
        ShopAddress?: string;
        ShopRegName?: string;
        ShopRegAddressLine1?: string;
        ShopRegAddressLine2?: string;
        ShopRegAddressLine3?: string;
        ShopRegId?: string;
        ShopTaxId?: string;
        ChargeVatRate?: number;
        PosProcessMode?: string;
        PosScreenType?: string;
        WeightBarcodePrefix?: string;
        PointRedeemOneBaht?: number;
        DiscRoundMethod?: PsParaGenTypeDiscRoundMethod;
        AllowSaleOverStock?: number;
        PromptPayLink?: string;
        QRCodeAccount?: string;
        PsParaDefault1?: boolean;
        ShopLogoOnFrontScreen?: string;
        ShopLogoOnReceipt?: string;
        RecptHeadMesg1?: string;
        RecptHeadMesg2?: string;
        RecptHeadMesg3?: string;
        RecptHeadMesg4?: string;
        RecptHeadMesg5?: string;
        RecptHeadMesg6?: string;
        RecptFootMesg1?: string;
        RecptFootMesg2?: string;
        RecptFootMesg3?: string;
        RecptFootMesg4?: string;
        RecptFootMesg5?: string;
        RecptFootMesg6?: string;
        RecptFootMesg7?: string;
        RecptFootMesg8?: string;
        RecptFootMesg9?: string;
        RecptFootMesg10?: string;
        RecptNoBarcodeFg?: PsParaGenTypeRecptNoBarcodeFg;
        PsParaDefault2?: boolean;
        SelectSellingPriceFg?: PsParaGenTypeSelectSellingPriceFg;
        ReceiptPrinterType?: PsParaGenTypeReceiptPrinterType;
        SalesDocFg?: PsParaGenTypeSalesDocFg;
        SalesVatType?: string;
        EjournalFg?: PsParaGenTypeEjournalFg;
        NoOfRecptCopy?: number;
        PrintOrderFg?: PsParaGenTypePrintOrderFg;
        PrintQueueFg?: PsParaGenTypePrintQueueFg;
        ItemOnRecptMethod?: PsParaGenTypeItemOnRecptMethod;
        RecptSumItemQtyFg?: PsParaGenTypeRecptSumItemQtyFg;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        PsParaFullName?: string;
        TaxInvoiceDateFg?: number;
        BackOfficeUpLoadURL?: string;
        RecptHeadMesgFontSize?: number;
        RecptHeadMesgTextAlign?: number;
        RecptFootMesgFontSize?: number;
        RecptFootMesgTextAlign?: number;
        CountLockSignInWrongPassInDay?: number;
    }

    export namespace PsParaRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShopName';
        export const localTextPrefix = 'Administration.PsPara';
        export const lookupKey = 'Administration.PsPara';

        export function getLookup(): Q.Lookup<PsParaRow> {
            return Q.getLookup<PsParaRow>('Administration.PsPara');
        }
        export const deletePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const insertPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';
        export const readPermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:View';
        export const updatePermission = '1POSBASE:โปรไฟล์ของกิจการ:พารามิเตอร์ระบบ:Modify';

        export declare const enum Fields {
            Id = "Id",
            ShopName = "ShopName",
            BranchName = "BranchName",
            ShopAddress = "ShopAddress",
            ShopRegName = "ShopRegName",
            ShopRegAddressLine1 = "ShopRegAddressLine1",
            ShopRegAddressLine2 = "ShopRegAddressLine2",
            ShopRegAddressLine3 = "ShopRegAddressLine3",
            ShopRegId = "ShopRegId",
            ShopTaxId = "ShopTaxId",
            ChargeVatRate = "ChargeVatRate",
            PosProcessMode = "PosProcessMode",
            PosScreenType = "PosScreenType",
            WeightBarcodePrefix = "WeightBarcodePrefix",
            PointRedeemOneBaht = "PointRedeemOneBaht",
            DiscRoundMethod = "DiscRoundMethod",
            AllowSaleOverStock = "AllowSaleOverStock",
            PromptPayLink = "PromptPayLink",
            QRCodeAccount = "QRCodeAccount",
            PsParaDefault1 = "PsParaDefault1",
            ShopLogoOnFrontScreen = "ShopLogoOnFrontScreen",
            ShopLogoOnReceipt = "ShopLogoOnReceipt",
            RecptHeadMesg1 = "RecptHeadMesg1",
            RecptHeadMesg2 = "RecptHeadMesg2",
            RecptHeadMesg3 = "RecptHeadMesg3",
            RecptHeadMesg4 = "RecptHeadMesg4",
            RecptHeadMesg5 = "RecptHeadMesg5",
            RecptHeadMesg6 = "RecptHeadMesg6",
            RecptFootMesg1 = "RecptFootMesg1",
            RecptFootMesg2 = "RecptFootMesg2",
            RecptFootMesg3 = "RecptFootMesg3",
            RecptFootMesg4 = "RecptFootMesg4",
            RecptFootMesg5 = "RecptFootMesg5",
            RecptFootMesg6 = "RecptFootMesg6",
            RecptFootMesg7 = "RecptFootMesg7",
            RecptFootMesg8 = "RecptFootMesg8",
            RecptFootMesg9 = "RecptFootMesg9",
            RecptFootMesg10 = "RecptFootMesg10",
            RecptNoBarcodeFg = "RecptNoBarcodeFg",
            PsParaDefault2 = "PsParaDefault2",
            SelectSellingPriceFg = "SelectSellingPriceFg",
            ReceiptPrinterType = "ReceiptPrinterType",
            SalesDocFg = "SalesDocFg",
            SalesVatType = "SalesVatType",
            EjournalFg = "EjournalFg",
            NoOfRecptCopy = "NoOfRecptCopy",
            PrintOrderFg = "PrintOrderFg",
            PrintQueueFg = "PrintQueueFg",
            ItemOnRecptMethod = "ItemOnRecptMethod",
            RecptSumItemQtyFg = "RecptSumItemQtyFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            PsParaFullName = "PsParaFullName",
            TaxInvoiceDateFg = "TaxInvoiceDateFg",
            BackOfficeUpLoadURL = "BackOfficeUpLoadURL",
            RecptHeadMesgFontSize = "RecptHeadMesgFontSize",
            RecptHeadMesgTextAlign = "RecptHeadMesgTextAlign",
            RecptFootMesgFontSize = "RecptFootMesgFontSize",
            RecptFootMesgTextAlign = "RecptFootMesgTextAlign",
            CountLockSignInWrongPassInDay = "CountLockSignInWrongPassInDay"
        }
    }
}
